// src/hooks/useBreakpoint.ts
import { useTheme } from "@mui/system";
import useMediaQuery from "@mui/material/useMediaQuery";

export const useBreakpoint = () => {
  const theme = useTheme();

  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));
  const isMd = useMediaQuery(theme.breakpoints.only("md"));
  const isLg = useMediaQuery(theme.breakpoints.only("lg"));
  const isXl = useMediaQuery(theme.breakpoints.only("xl"));

  const current = isXs
    ? "xs"
    : isSm
      ? "sm"
      : isMd
        ? "md"
        : isLg
          ? "lg"
          : isXl
            ? "xl"
            : "unknown";

  return { current, isXs, isSm, isMd, isLg, isXl };
};
